<script setup>
import { cloneDeep } from 'lodash';
import {
  ref, reactive, computed, onMounted, watch,
} from 'vue';
import { propsEditor } from './editores_mixins';
import IndicadorVariable from './IndicadorVariable.vue';

// TODO: De momento usamos el slider que ya tenemos, no voy a buscar otro ahora
/* global $ */

const props = defineProps(propsEditor());
const emits = defineEmits(['update:modelValue', 'eliminarVariableDisponible']);

const modelo = reactive(cloneDeep(props.modelValue));

watch(props.modelValue, () => Object.assign(modelo, props.modelValue));

// De 0 a 1, los porcentajes se almacenan como 0.2, 0.7 etc
const totalFormulado = computed(() => {
  const suma = modelo.formula_variables
    .map((fv) => parseFloat(fv.valor || 0))
    .reduce((a, b) => a + b, 0);
  return (suma || 0).toFixed(2);
});

// Primero buscamos en las ya asignadas, si no la encontramos, en las
// disponibles
function getVariableByKey(key) {
  return modelo.formula_variables.find((fv) => fv.nombre_variable === key);
}

// Primero buscamos en las ya asignadas, si no la encontramos, en las
// disponibles
function ensureVariable(key) {
  let variable = getVariableByKey(key);
  if (variable) {
    return variable;
  }

  variable = props.variablesDisponibles.find((fv) => fv.nombre_variable === key);
  modelo.formula_variables.push(variable);
  return variable;
}

function setValorSlider($slider, key, valorInicial) {
  const value = Math.round(valorInicial);
  // Tooltip
  $slider.find('.ui-slider-tooltip').text(`${value}%`);

  const variable = ensureVariable(key);
  variable.valor = value / 100;
  modelo.formula_variables = modelo.formula_variables.filter((fv) => fv.valor > 0);
  emits('update:modelValue', modelo);
}

const root = ref(null);

onMounted(() => {
  $(root.value).find('.slider').each(function cargarSlider() {
    const $slider = $(this);
    const key = $slider.data('key');
    const variableInicial = getVariableByKey(key) || { valor: 0 };
    const valorInicial = Math.round(variableInicial.valor * 100);
    $slider.slider({
      min: 0,
      max: 100,
      step: 1,
      value: valorInicial,
      create(event, _ui) {
        // Crear elemento sobre el que aplicar tooltip con porcentaje actual
        $(event.target).find('.ui-slider-handle').append(`<span class="ui-slider-tooltip">${valorInicial}%</span>`);
      },
      slide(event, ui) {
        // Hay que volver a buscarla porque puede que la hayan quitado (valor a 0) y vuelto a poner
        // por lo que sería otro objeto distinto al cargado arriba en variableIncial
        const variable = ensureVariable(key);
        // Quitamos el valor anterior
        const totalSinActual = totalFormulado.value - (variable.valor || 0);
        // Sumamos el valor nuevo
        const futuroTotal = totalSinActual + ui.value / 100;

        if (futuroTotal > 1) {
          const valorMaximo = (100 - totalSinActual * 100);
          $slider.slider('value', valorMaximo);
          setValorSlider($slider, key, valorMaximo);
          return false;
        }
        setValorSlider($slider, key, ui.value);
        return true;
      },
    });
  });
});
</script>

<template>
  <div ref="root">
    <h3 class="m-b">
      {{ $I18n.t('porcentaje_aplicado') }}:
      <span
        class="label m-b m-l porc-total"
        :class="`${totalFormulado == 1 ? 'label-success' : 'label-warning'}`"
      >
        {{ Math.round(totalFormulado * 100) }}%
      </span>
    </h3>
    <table class="table table-striped">
      <tbody>
        <tr
          v-for="variable in variablesDisponibles"
          :key="variable.id"
        >
          <td class="col-min">
            <IndicadorVariable :variable="variable" />
          </td>
          <td class="variable-label">
            {{ variable.label }}
          </td>
          <td class="slider-wrapper">
            <div class="slider" :data-key="variable.key"></div>
          </td>
          <td class="col-min">
            <div
              class="btn btn-white btn-sm"
              @click="$emit('eliminarVariableDisponible', variable)"
            >
              <i class="fa fa-times text-danger"></i>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style scoped>
  .table tbody tr {
    height: 60px;
  }

  .table tbody tr td:first-child {
    font-weight: bold;
  }

  .slider-wrapper {
    max-width: 60%;
    width: 60%;
  }

  .slider {
    margin-left: 30px;
  }

  .porc-total {
    font-size: 75%;
  }

  .variable-label{
    white-space: normal;
    min-width: 30%;
  }
</style>
